
import * as yup from 'yup';
import { validateObject } from './functions';

const etapasComIdade = [
    { etapas: [1], min: 0, max: 6 },
    { etapas: [2], min: 3, max: 9 },
    { etapas: [14], min: 4, max: 50 },
    { etapas: [15, 16], min: 5, max: 50 },
    { etapas: [17], min: 6, max: 50 },
    { etapas: [18], min: 7, max: 50 },
    { etapas: [19], min: 8, max: 50 },
    { etapas: [20], min: 9, max: 50 },
    { etapas: [21], min: 10, max: 50 },
    { etapas: [41], min: 10, max: 50 },
    { etapas: [25, 26, 27, 28, 29, 35, 36, 37, 38], min: 12, max: 58 },
    { etapas: [39, 40], min: 13, max: 58 },
    { etapas: [40], max: 75 },
    { etapas: [69, 70, 72], min: 12, max: 94 },
    { etapas: [71], min: 15, max: 94 },
    { etapas: ['itinerarioFormativo'], min: 12, max: 94 },
    { etapas: ['socioeducativo'], min: 12 },
    { etapas: ['prisional'], min: 18 }
]

const getDateByRule = (code, tipo = 'min') => {
    const year = new Date().getFullYear()
    const regra = etapasComIdade.find(r =>
        r.etapas.includes(code) ||
        (r.etapas.includes('itinerarioFormativo') && code === 'itinerarioFormativo') ||
        (r.etapas.includes('socioeducativo') && code === 'socioeducativo') ||
        (r.etapas.includes('prisional') && code === 'prisional')
    )

    const idade = regra?.[tipo]
    if (!idade) return undefined

    return new Date(`01/01/${year - idade}`)
}

export const validationForm1 = yup.object().shape({
    codeBirthDate: yup.string().nullable(),
    // cpf: yup.string().min(10, 'Informe os 11 números do CPF').required('Informe o CPF ').typeError('Informe os 11 números do CPF'),
    cpf: yup.string().nullable(),
    completeName: yup.string().min(7, 'Nome completo: Informe o nome completo').required('Digite o nome'),
    birthDate: yup
        .date()
        .required('Insira uma data')
        .when(['codeBirthDate'], (codeBirthDate, schema) => {
            const minDate = getDateByRule(codeBirthDate, 'min')
            const maxDate = getDateByRule(codeBirthDate, 'max')

            let result = schema
            if (minDate) {
                result = result.min(minDate, `A idade mínima permitida para essa etapa é ${new Date().getFullYear() - minDate.getFullYear()} anos`)
            }
            if (maxDate) {
                result = result.max(maxDate, `A idade máxima permitida para essa etapa é ${new Date().getFullYear() - maxDate.getFullYear()} anos`)
            }
            return result
        }),
    filiation: yup.number().required().typeError('Selecione uma das opções de filiação'),
    responsible1: yup.string().when('filiation', {
        is: 1,
        then: yup.string().required(' informe a filiação 1').min(8, ' Informe o nome completo do responsavel'),
    }),
    responsible2: yup.string(),
    sex: yup.number().required().typeError('Selecione uma das opções de sexo'),
    colorRace: yup.number().moreThan(-1, 'Selecione uma das opções de Cor/Raça').required('Selecione uma das opções de Cor/Raça'),
    indigenousPeople: yup.number().when('colorRace', {
        is: 5,
        then: yup.number().required(' Selecione uma opção do povo Indígena').moreThan(0, ' Selecione uma opção do povo Indígena'),
    }),
    nationality: yup.number().required('Selecione uma das opções de nacionalidade').moreThan(0, 'Selecione uma das opções de nacionalidade'),
    nationalityCountry: yup.number().when('nationality', {
        is: 1,
        then: yup.number().required('Informe o País de Nascimento').moreThan(0, 'Informe o País de Nascimento'),
    }),
    uf: yup.string().when('nationality', {
        is: 1,
        then:
            yup.string().required(' informe o uf de nascimento'),
    }),
    cityBorn: yup.number().when('nationality', {
        is: 1,
        then: yup.number().required(' Informe a cidade de Nascimento').moreThan(0, ' Informe a cidade de Nascimento'),
    }),
    existsDeficiencyDisorder: yup.number().default(0),
    existsImpactfulLearningDisorder: yup.number().default(0),
    deficiencyDisorder: yup.array().when('existsDeficiencyDisorder', {
        is: 1,
        then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção de deficiência', value => {
            return validateObject(value);
        }),
    }),
    resourceEvaluationInep: yup
        .array()
        .required('Campo obrigatório')
        .test(
            'at-least-one-attribute',
            ' selecione pelo menos uma opção de recurso',
            function (value) {
                const { existsDeficiencyDisorder, existsImpactfulLearningDisorder } = this.parent;

                if (existsDeficiencyDisorder === 1 || existsImpactfulLearningDisorder === 1) {
                    // Garante que ao menos um campo seja true (1) no objeto
                    return value && Object.values(value).some((val) => val === 1);
                }

                return true; // Passa a validação se não tiver deficiência/transtorno
            }
        )

})

export const validationForm2 = yup.object().shape({
    countryResidence: yup.number().moreThan(0, ' Informe o País de residência').required(' Informe o País de residência'),
    areaResidence: yup.number().typeError(' escolha uma opção').required(' escolha uma opção'),
    cep: yup.string().when('countryResidence', {
        is: 76,
        then: yup.string().required(' Informe o cep').min(9, ' informe o cep completo')
    }).nullable(),
    differentiatedLocation: yup.number().moreThan(0, ' Informe a localização diferenciada').typeError(' Informe a localização').required(' Informe uma localização'),

})

export const validationForm3 = yup.object().shape({
    learningTrails: yup.number().nullable(),
    specializedEducationalService: yup.number().nullable(),
    isReceiveEducationElsewhere: yup.boolean().default(false),

    specializedEducationTypes: yup.array().when("specializedEducationalService", {
        is: (value) => {
            if (value === 1) {
                return true;
            }
            return false;
        },
        then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção , quando ', value => {
            return validateObject(value); // Chama a função validateObject para realizar a validação
        }),
    }).nullable(),
    receiveEducationElsewhere: yup.number().when('isReceiveEducationElsewhere', {
        is: true,
        then: yup.number().moreThan(0, ' selecione uma opção').required('selecione uma opção')
    }).nullable(),
    usesTransportPublic: yup.number().required(' selecione uma opção').moreThan(-1, ' Selecione uma opção'),
    responsiblePublicAuthority: yup.number().when('usesTransportPublic', {
        is: 1,
        then: yup.number().moreThan(0, ' Selecione uma opção').required(' Selecione uma opção')
    }).nullable(),
    vehicleTypes: yup.array().when('usesTransportPublic', {
        is: 1,
        then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
            return validateObject(value); // Chama a função validateObject para realizar a validação
        }),
    }).nullable(),
})

export function renderFormation(Transporte) {
    if (
        (Transporte.aclass.curricularUnit.learningTrails === 1 &&
            Transporte.aclass.curricularStructures.basicGeneralTraining === 0) ||
        Transporte.aclass.workingPlace < 2 ||
        Transporte.aclass.typeServices?.specializedEducationalService === 1
    ) {
        return true;
    } else {
        return false;
    }
}

export function desabilitaCampoRecebeEscolarização(valor) {
    const escolarizacao = valor?.typeServices?.curricularStage
    const tipoMediacao = valor?.typeMediation
    const localFuncionamento = valor?.workingPlace
    if (
        escolarizacao === 1 &&
        tipoMediacao === 1 &&
        (localFuncionamento === 0 || localFuncionamento === 1)
    ) {
        return true
    } else {
        return false;
    }
}